export const CMS_ADAPTER_TIMEOUT = 15000
